class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.closest('.cart-notification-modal');
    this.continueButton = this.querySelector('.cart-notification__continue');
  }

  connectedCallback() {
    this.onClickContinueHandler = this.onClickContinue.bind(this);
    this.continueButton.addEventListener('click', this.onClickContinueHandler);
  }

  disconnectedCallback() {
    this.continueButton.removeEventListener('click', this.onClickContinueHandler);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    console.log("key", this.cartItemKey)
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = getInnerHtmlFromText(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.open();
    setTimeout(() => {
      const freeProductSlider = document.querySelector(".cart__recommendation-list slider-component");
      if(freeProductSlider) freeProductSlider.init();
    }, 100);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  open() {
    this.dialog.show(this.activeElement);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onClickContinue() {
    this.dialog.hide();
  }
}

customElements.define('cart-notification', CartNotification);